import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { featureOn } from '../../../feature-flag';
import { GlobalStore } from '../../../store/global.global-store';
import { permissionsFetched } from '../../shared/shared.global-service';

export const planningCalendarGuard: CanActivateFn = async () => {
    const store = inject(GlobalStore);
    const router = inject(Router);

    if (featureOn.NEW_CALENDAR) {
        try {
            // A direct URL must wait for current ACL; failed refreshes must not reuse stale rights.
            const aclReady = permissionsFetched() || await store.fetchAcl();
            if (aclReady && store.isAllowed('calendar.read')()) return true;
        } catch {
            // Deny access when ACL cannot be loaded.
        }
    }

    return router.createUrlTree(['/content/dashboard']);
};
